import { SponsorLogoProps, SponsorType } from './index';

export const SPONSORS = new Map<
  SponsorType,
  Array<SponsorLogoProps>
>([
    [ 'Session',
        [
            { image: 'gmo-internet.png', alt: 'GMOインターネットグループ', url: 'https://developers.gmo.jp/' },
            { image: 'wealthnavi.png', alt: 'ウェルスナビ株式会社', url: 'https://corp.wealthnavi.com/' },
            { image: 'persol-career.png', alt: 'パーソルキャリア株式会社', url: 'https://www.persol-career.co.jp/' },
            { image: 'saisoncard.png', alt: '株式会社クレディセゾン', url: 'https://corporate.saisoncard.co.jp/' },
            { image: 'ly.png', alt: 'LINEヤフー株式会社', url: 'https://www.lycorp.co.jp/ja/technology/' },
            { image: 'simplex.png', alt: 'シンプレクス株式会社', url: 'https://recruit.simplex.holdings/' },
            { image: 'nri.png', alt: '株式会社 野村総合研究所', url: 'https://www.nri.com/jp/' },
            { image: 'nttdata.png', alt: '株式会社NTTデータグループ', url: 'https://www.nttdata.com/global/ja/' },
            { image: 'ulsystems.png', alt: 'ウルシステムズ株式会社', url: 'https://www.ulsystems.co.jp/' },
            { image: 'microsoft.png', alt: '日本マイクロソフト株式会社', url: 'https://www.microsoft.com/ja-jp/' },
        ]
    ],
    [
      'Booth',
      [
          { image: 'gmo-internet.png', alt: 'GMOインターネットグループ', url: 'https://developers.gmo.jp/' },
          { image: 'samuraism.png', alt: '株式会社サムライズム', url: 'https://samuraism.com/' },
          { image: 'casareal.png', alt: '株式会社カサレアル', url: 'https://www.casareal.co.jp/' },
          { image: 'wealthnavi.png', alt: 'ウェルスナビ株式会社', url: 'https://corp.wealthnavi.com/' },
          { image: 'ly.png', alt: 'LINEヤフー株式会社', url: 'https://www.lycorp.co.jp/ja/technology/' },
          { image: 'demae-can.png', alt: '株式会社出前館', url: 'https://recruit.demae-can.co.jp/' },
          { image: 'microsoft.png', alt: '日本マイクロソフト株式会社', url: 'https://www.microsoft.com/ja-jp/' },
          { image: 'oracle.png', alt: 'Oracle Global Services', url: 'https://www.oracle.com/jp/java/' },
          { image: 'findy.png', alt: 'ファインディ株式会社', url: 'https://findy.co.jp/' },

      ]
    ],
    [
        'Lunch',
        [
            { image: 'cybozu.png', alt: 'サイボウズ株式会社', url: 'https://tech.cybozu.io/' }
        ]
    ],
    [
        'Logo',
        [
            { image: 'baby-job.png', alt: 'BABY JOB株式会社', url: 'https://baby-job.co.jp/' },
            { image: 'sms.png', alt: '株式会社エス・エム・エス', url: 'https://careers.bm-sms.co.jp/engineer' }
        ]
    ],
    [
        'Tool',
        [
            { image: 'backlog.png', alt: '株式会社ヌーラボ', url: 'https://backlog.com/ja/' }
        ]
    ]
  ]
);
